<template>
  <div class="about-us" >
    <h2 class="about-title-h2">About Us</h2>
    <h5 class="about-title-h5">
    <p>We are a small team of software developers and designers from Manchester, England. Our company, {{projCompany}}, was founded by <a href="https://www.linkedin.com/in/andrewbrier/" class="bldr-external-link" target="_blank">Andrew Brier</a> a 30+ year veteran of the Internet Industry.</p>
    <img class="about-img-icon3d" src="../assets/icon3d.png" alt="icon3d - the best 3D launcher ever"/>

    <p>In 1999 we released Icon3D, a 3D desktop application launcher developed in C and OpenGL and released as <a href="https://en.wikipedia.org/wiki/Shareware" class="bldr-external-link">shareware</a>.</p>    
    <p class="tldr"><s>tl/dr list of everything we've created</s> </p>
    <p>Since then we've built products in many different Internet and software niches. </p>
    <p>By today's standards our style and approach may be considered unconventional. However our outcomes are robust and we've always stayed loyal to our key driver... innovate, to create.</p>
    
    </h5>
    <div class="about-img-wrapper">
      <a class="about-social" href="https://x.com/toolsie_">
      <img class="about-img" src="../assets/toolsie.png" alt="toolsie logo"/>
      <q-badge class="about-badge" color="cyan-8" label="@toolsie_"></q-badge>
      </a>
    </div>

  </div>
  
</template>

<style scoped>

  .tldr{
    font-size:1em;
  }

  .about-us{
    text-align: center;
    margin: 100px auto;
    
    max-width:800px;
  }
  .about-img-wrapper{
    text-align: center;    
    margin: 0 auto 24px auto;    
    display:flex;
    flex-direction: column;
    width: 100px;

  }
  .about-img{    
    width: 100px;
    border-radius: 100px;
    height: auto;    
    border: 3px solid #392b4b;
    box-shadow: 0 24px 40px -10px rgba(0, 0, 0, 0.2), 0 32px 56px -16px rgba(0, 0, 0, 0.2);
    margin:0px 0px;
  }
  .about-badge{
    vertical-align: top;
    margin:-2px auto 0 auto;
  }

  .about-img-icon3d{
    width: 200px;
    border-radius: 200px;
    height: auto;    
    border: 3px solid #392b4b;
    box-shadow: 0 24px 40px -10px rgba(0, 0, 0, 0.2), 0 32px 56px -16px rgba(0, 0, 0, 0.2);
    margin:0 0px 0 0px;
  }

  .about-title-h2 {
    letter-spacing: unset;
    padding:unset;
    margin-block-end: 0px;
    margin-block-start: 0px;
    font-weight: 500;
    line-height:1.2em !important;
    font-size: 4rem;  
    color: #474747;
    margin:0 20px 20px 20px;
  }
  .about-title-h4{
    padding:unset;
    font-size: 2rem;
    margin:0 20px 64px 20px;
  }
  .about-title-h5{
    padding:0 24px 0 24px;
  }
  @media (max-width: 620px) { 
    .about-title-h2 {
      font-size: 3rem; 
      padding:0 20px 0 20px;
      margin-bottom: 10px;
    }
    .about-title-h4 {
      font-size: 1.5rem; 
      padding:0 20px 0 20px;
      margin-bottom: 48px;
    }
    .about-title-h5{
      font-size:1rem;
      padding:0 20px 0 20px;
    }
  }
  body.body--dark .about-title-h2 {
    color: #333; /* 158bff, 1976d2 */
  }
  body.body--dark .about-title-h4 {
    color: #444; /* 158bff, 1976d2 */
  }
  body.body--dark .about-title-h5 {
    color: rgb(68,68,68); /* 158bff, 1976d2 */
  }

</style>

<script setup>

    import { onMounted } from 'vue';
    import { projCompany } from '../../../constants';
    
    onMounted(async () => {
        
    });

</script>